/**
 * Random-drawing pre-check, shared by the audience screen's Draw button and
 * the host panel's Draw button. The server picks the actual winner (see
 * handleDrawing in Cerebrex/utils/socketHandler.js) and ignores any winner a
 * client sends. The client checks the standings first only so it can say why
 * nothing happened, because the server drops a draw with no reply.
 */
import api from './api';

export interface DrawingStanding {
  teamName: string;
  rank: number;
}

// Length of the audience-screen spin before the winner is revealed
// (PresentationView's slot-machine schedule plus its reveal delay).
export const DRAWING_SPIN_MS = 4000;

// Teams ranked 1st and 2nd already win prizes, so they are not eligible.
// Standings already exclude teams marked as left early. Mirrors the server.
export function eligibleDrawingPool(standings: DrawingStanding[]): string[] {
  return standings.filter((s) => s.rank > 2 && s.teamName).map((s) => s.teamName);
}

// Resolves to an error message when a draw cannot run, or null when it can.
export async function drawingBlockedReason(eventId: string): Promise<string | null> {
  try {
    const res = await api.get(`/api/scores/event/${eventId}/standings`);
    const standings = (res.data?.data?.standings ?? []) as DrawingStanding[];
    return eligibleDrawingPool(standings).length > 0
      ? null
      : 'No eligible teams — everyone is in 1st/2nd or has left.';
  } catch {
    return 'Could not load standings — try again.';
  }
}
